export default "__VITE_ASSET__Cz7kEH_7__"